<template>
    <div class="wb-divider"
         :class="classes"
    />
</template>

<script setup lang="ts">
    const props = withDefaults(defineProps<{
        color?: 'light'
    }>(), {
        color: 'light',
    })

    const classes = computed(() => ({
        [`_${props.color}`]: props.color,
    }))
</script>

<style scoped lang="scss">
    .wb-divider {
        height: 1px;
        background-color: var(--color-divider);

        &._light {
            --color-divider: var(--blue-100);
        }
    }
</style>
